import ApiService from "../ApiService";
const { REACT_APP_REST_ENDPOINT } = process.env;

export default class CorsiService {

    static getAllCorsi = () => {
        let url = `${REACT_APP_REST_ENDPOINT}/corsi`;
        return ApiService.getRudeRequest(url);
      };

    static createCorso = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/corsi/create`;
            ApiService.postRequest(resolve, reject, url, data)
        });
    }

    static updateCorso = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/corsi/update`;
            ApiService.putRequest(resolve, reject, url, data)
        });
    }

    static getCorsiByParams = (params) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/corsi/find`;
            ApiService.postRudeRequest(resolve, reject, url, params)
        });
      };  

    static findContenutiByIdCorso = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/corsi/findContenutiById`;
            ApiService.postRequest(resolve, reject, url, data)
        });
    }

    static deleteCorso = (id) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/corsi/delete`;
            ApiService.delete(resolve, reject, url, id)
        });
    }

    static findCorsiByIdUtente = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/corsi/findByUtente`;
            ApiService.postRequest(resolve, reject, url, data)
        });
    }

    static updateStateCorso = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/corsi/updateStato`;
            ApiService.putRequest(resolve, reject, url, data)
        });
    }

    static addDocumentCorsi = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/corsi/addDocument`;
            ApiService.postRequest(resolve, reject, url, data)
        });
    }
    static findDocumentiByIdCorso = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/corsi/findDocumentiByIdCorso`;
            ApiService.postRequest(resolve, reject, url, data)
        });
    }

    static deleteDocumentCorsi = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/corsi/deleteDocument`;
            ApiService.delete(resolve, reject, url, data)
        });
    }

    static findCorsoById = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/corsi/show`;
            ApiService.postRequest(resolve, reject, url, data)
        });
    }

    static uploadImgCorso = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/corsi/uploadImage`;
            ApiService.postRequest(resolve, reject, url, data)
        });
      }

       static applyPartnerSconto = (data) => {
        return new Promise((resolve, reject) => {
            // Questo è l'endpoint che creeremo nel backend
            const url = `${REACT_APP_REST_ENDPOINT}/sconti-superpartner/createOrUpdate`;
            // Usiamo postRequest perché potrebbe essere una creazione o un aggiornamento
            ApiService.postRequest(resolve, reject, url, data);
        });
    };

       static applySconto = (data) => {
        return new Promise((resolve, reject) => {
            // Assumiamo un endpoint PUT/PATCH per aggiornare parzialmente il corso
            const url = `${REACT_APP_REST_ENDPOINT}/corsi/applySconto`;
            // Passiamo sia l'id del corso che lo sconto nel corpo della richiesta
            ApiService.putRequest(resolve, reject, url, { id_corso: data.id_corso, sconto: data.sconto });
        });
    };
      

}